module.exports = __webpack_public_path__ + "img/product-teacher-bjgl-01.32487a84.png";